import PersonIcon from '@material-ui/icons/Person';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import React from 'react';
import {Employee} from '../Utils/EmployeeSchedulesCompiler';

type Props = {
    employee : Employee;
    color ?: 'inherit' | 'primary' | 'secondary' | 'action' | 'disabled' | 'error';
    fontSize ?: 'inherit' | 'default' | 'small' | 'large';
};

const EmployeeTypeIcon : React.FC<Props> = ({employee, ...rest} : Props) => {
    if (employee.type === 'employee') {
        return <PersonIcon {...rest}/>;
    }

    return <PersonOutlineIcon {...rest}/>;
};

export default EmployeeTypeIcon;
